import { render, staticRenderFns } from "./CustomersLocationsManagement.vue?vue&type=template&id=5d78911e&"
import script from "./CustomersLocationsManagement.vue?vue&type=script&lang=js&"
export * from "./CustomersLocationsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports